import { get } from 'lodash';

export const SOURCES = {
  // AEM: 'AEM', // NO LONGER SUPPORTED
  CS: 'CONTENT_STACK',
};

export const asBoolean = (value, fallback = false) => {
  switch (typeof value) {
    case 'string':
      return value.toLowerCase() === 'true';
    case 'boolean':
      return value;
    case 'number':
      return value !== 0;
    default:
      return fallback;
  }
};

export const asInt = (value, fallback = 0) => {
  switch (typeof value) {
    case 'string':
    case 'number': {
      const x = parseInt(value, 10);
      return Number.isNaN(x) ? fallback : x;
    }
    case 'boolean':
      return value ? 1 : 0;
    default:
      return fallback;
  }
};

export const objOrParse = value => {
  let result = {};
  switch (typeof value) {
    case 'string': {
      try {
        result = JSON.parse(value);
      } catch (err) {
        console.error(err);
      }
      break;
    }
    case 'object': {
      result = { ...value };
      break;
    }
    default: {
      break;
    }
  }
  return result;
};

export const initCMS = (cms = {}, labels = {}, messages = {}, uiConfig = {}) => {
  const props = {
    cms: objOrParse(cms),
    labels: objOrParse(labels),
    messages: objOrParse(messages),
    uiConfig: objOrParse(uiConfig),
  };

  const source = props.cms.source || SOURCES.CS;

  const getContent = (path, fallback) => get(props.cms, path, fallback);
  const getLabel = (key, fallback) => get(props.labels, key, fallback);
  const getMessage = (key, fallback) => get(props.messages, key, fallback);
  const getCMSGlobal = (key, fallback) => get(props.uiConfig.cmsGlobal, key, fallback);
  const getUIFlag = (key, fallback) => get(props.uiConfig.flags, key, fallback);

  return {
    props,
    source,
    getContent,
    getLabel,
    getMessage,
    getCMSGlobal,
    getUIFlag,
    asBoolean,
    asInt,
  };
};
